import React from "react";
import PropTypes from "prop-types";


// StyleGuide = molecules/global/progress-bar

class ProgressBar extends React.Component {
  render() {
    const {
      children,
      percent,
      bgColor,
      barColor,
      className
    } = this.props;

    return (
      <div className={`ProgressBar progress ${bgColor ? `bg-${bgColor}` : ''} ${className}`}>
        { typeof percent === 'object' ? (
          Object.keys(percent).map((key, i) => (
            <div
              key={i}
              className={`progress-bar bg-${key}`}
              role="progressbar"
              aria-label="Progress"
              style={{ width: `${parseFloat(percent[key])}%` }}
            />
          ))
        ) : (
          <div
            className={`progress-bar ${barColor ? `bg-${barColor}` : ''}`}
            role="progressbar"
            aria-label="Progress"
            style={{ width: `${parseFloat(percent)}%` }}
          >
            { children }
          </div>
        )}
      </div>
    );
  }
}

ProgressBar.propTypes = {
  percent: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.objectOf(
      PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
      ])
    )
  ]).isRequired,
  bgColor: PropTypes.string,
  barColor: PropTypes.string,
  className: PropTypes.string
};

ProgressBar.defaultProps = {
  className: ''
};

export default ProgressBar;
